<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")


  section.u-mt-md
    .grid.is-tablet-6
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Growth",
    "pageDesc":"Creating a growth driven strategy that helps you in increasing revenues and achieving higher ROI rates.",
    "mantra":"Accelerate your business |growth.",
    "sec1Items":{
      "1":{
        "title":"Growth strategy",
        "desc":"Creating a growth stratgey to help capaoitzien on the market opportunities and enhance your internal operations in a way that accelerates growth. "
      },
      "2":{
        "title":"Business audit",
        "desc":"Examining your business operations and advising you on the necessary changes that would help you develop a stronger market presence and gain more shares."
      }
    },
    "sec2":"Growth planning breakdown.",
    "sec2Items":{
      "1":{
        "title":"Identify growth gaps",
        "desc":"Whether internally or externally, we look for growth opportunities that you didn't capitalize on and work with you to build a strong criteria of what can be called a growth opportunity. "
      },
      "2":{
        "title":"Collaborate to prepare launch",
        "desc":"Doing both outsourcing and internal planning efforts needs to scale the business and leveraging on our partnerships"
      },
      "3":{
        "title":"Solution delivery",
        "desc":"Working as one team on delivering the initiatives planned. Monitoring your growth curve and optimizing along the way for faster impact."
      }
    },
    "cta":"Grow your <br> business now."
  },
  "ar": {
    "pageTitle":"استراتيجيات النمو",
    "pageDesc":"نعمل على إنشاء استراتيجية مدفوعة بالنمو التي تساعدك في زيادة الإيرادات وتحقيق معدلات أعلى على العائد من الاستثمار ROI.",
    "mantra":"استراتيجيات النمو |لتسريع نجاح اعمالك.",
    "sec1Items":{
      "1":{
        "title":"استراتيجية النمو",
        "desc":"نعمل على إنشاء استراتيجية النمو لمساعدتك على الازدهار داخل السوق وكذلك تعزيز عملياتك الداخلية بطرق تسرع من نموك."
      },
      "2":{
        "title":"تدقيق الأعمال التجارية",
        "desc":"نعمل على دراسة العمليات التي تتبعها في عملك، ونقدم لك المشورة اللازمة بشأن التغييرات اللازمة التي تساعدك على تطوير وجود أقوى في السوق وكسب المزيد من الأسهم."
      }
    },
    "sec2":"التخطيط الفعال من أجل النمو. ",
    "sec2Items":{
      "1":{
        "title":"تحديد فجوات النمو",
        "desc":"سواء داخليًا أو خارجيًا، نبحث عن فرص النمو التي لم تفكر فيها أو تستغلها ونعمل معك من أجل بناء معايير قوية لتحويل كل هذه الفرص إلى عوامل تقودك تجاه النمو."
      },
      "2":{
        "title":"التعاون لإعداد الإطلاق",
        "desc":"نقوم بكل الجهود من الاستعانة بالمصادر الخارجية والتخطيط الداخلي إلى توسيع نطاق الأعمال والاستفادة من شراكتنا."
      },
      "3":{
        "title":"توصيل الحلول",
        "desc":"نعمل كفريق واحد من أجل تنفيذ المبادرات المخطط لها، ومراقبة منحنى النمو الخاص بك وتحسينه على طول الطريق للحصول على تأثير أسرع."
      }
    },
    "cta":"خطط لتنمية <br> عملك الآن."
  }
}
</i18n>
